import { SummaryPanelWebComponent } from './component/SummaryPanelWebComponent';
import { WEB_COMPONENT_SUMMARY_PANEL } from '../../webcomponents.constants';

export { SummaryPanelWebComponent };

window.customElements.define(WEB_COMPONENT_SUMMARY_PANEL, SummaryPanelWebComponent);
